export enum RouteName {
  cases = "cases",
  edCaseDetails = "ed-case-details",
  ift = "ift",
  iftCaseDetails = "ift-case-details",
  iftReports = "ift-reports",
  mih = "mih",
  mihCaseDetails = "mih-case-details",
  mihReports = "mih-reports",
  messaging = "messaging",
  statuses = "statuses",
  iftStatuses = "ift-statuses",
  logout = "logout",
  login = "login",
  handleSsoToken = "auth-handle-token",
  passwordForgot = "password-forgot",
  passwordReset = "password-reset",
  notFound = "not-found",
}
